module.exports = __webpack_public_path__ + "media/images/client-32-0d69fcd49e412c7c860c790df2374a59.png";